import React from 'react';
import { lotAccessLegendItems, mapLegendItems } from './mapLegendData';

export default function MapLegends() {
    const legendItems = mapLegendItems.map((item, index) => (
        <div key={index} className="w-80">
            <i className={`${item.icon} ${item.color} text-2xl`} />
            <span>{item.text}</span>
        </div>
    ));

    const lotAccesslegendItems = lotAccessLegendItems
        .filter(item => item.text !== 'Trackout Control Device')
        .map((item, index) => (
            <div key={index} className="w-80">
                <i className={`${item.icon} ${item.color} text-2xl`} />
                <span>{item.text}</span>
            </div>
        ));

    return (
        <div className="flex flex-col">
            <span className="mx-4 mt-4 mb-2 text-xl font-semibold">Legend</span>
            <hr />
            <div className="mx-4 mt-2 flex flex-wrap justify-between">{legendItems}</div>
            <br />
            <span className="mx-4 mt-4 mb-2 text-xl font-medium">Lot Access Modifications</span>
            <span className="mx-4">
                These are used when the lot is started and placed where the proposed driveway is to be installed to
                allow for lot access. Example: Silt Fence is removed for the driveway to allow work on the lot and a
                different protection is installed in its place.
            </span>
            <span className="mx-4 mt-2">Installation date is correlated to the lot start date.</span>
            <div className="mx-4 mt-2 pb-2 flex flex-wrap justify-between">
                {lotAccesslegendItems}
                <div className="w-80 mt-1">
                    <div className="mx-1.5 iconCircle font-serif font-semibold text-sm w-[22px] h-[22px]">T</div>
                    <span>Trackout Control Device</span>
                </div>
                <div className="w-80" />
                <div className="w-80" />
            </div>
        </div>
    );
}
